export default {
	listing: [],
	paginator: {}
}